export default __webpack_public_path__ + "static/media/tutorial03.bf3ff669.jpg";